<template>
  <fragment>
    <card>
      <template slot="header">
        <translate tag="h3">Registration zones:</translate>
      </template>
      <el-table class="table-striped"
                :data="value">
        <slot name="tableColumns">
          <el-table-column :label="'Zone' | translate">
            <template slot-scope="props">
              <div class="form-group has-label">
                <el-select class="select-success full-width"
                           allow-create
                           :placeholder="'Type zone name or select from list' | translate"
                           :value="props.row.zone"
                           filterable
                           @input="(value) => props.row.zone = value"
                           reserve-keyword
                           >
                  <el-option
                    v-for="choice in PREDEFINED_ZONES"
                    :key="choice.key"
                    :label="choice.name"
                    :value="choice.key">
                  </el-option>
                </el-select>
              </div>
            </template>
          </el-table-column>
          <el-table-column :label="'IP Pattern' | translate">
            <template slot-scope="props">
              <el-tooltip :content="'Fill IP-address or IP-pattern' | translate" placement="top">
                <fg-input required v-model="props.row.pterm" placeholder="192.168.0.%"/>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column>
            <template slot-scope="props">
              <el-tooltip :content="'Delete' | translate" placement="top">
                <p-button type="danger" size="sm" icon @click="(e) => handleDelete(e, props.$index)">
                  <i class="fa fa-times"/>
                </p-button>
              </el-tooltip>
            </template>
          </el-table-column>
        </slot>
      </el-table>
      <template slot="footer">
        <el-tooltip :content="'Add zone' | translate" placement="top">
          <p-button type="success" size="sm" icon @click="(e) => addField()">
            <i class="fa fa-plus"/>
          </p-button>
        </el-tooltip>
      </template>
    </card>
  </fragment>
</template>

<script>

  import {Table, TableColumn, Tooltip, Select, Option} from 'element-ui'


  export default {
    name: 'PrintTerminalEditor',
    components: {
      [Table.name]: Table,
      [TableColumn.name]: TableColumn,
      [Tooltip.name]: Tooltip,
      [Select.name]: Select,
      [Option.name]: Option,
    },
    props: {
      value: {
        type: Array,
        default: () => []
      }
    },
    data () {
      return {
        PREDEFINED_ZONES: [
          {'key': 'vvc', 'name': this.$gettext('VDNH')},
          {'key': 'vvc_69', 'name': this.$gettext('VDNH Pav. 69')},
          {'key': 'vvc_75', 'name': this.$gettext('VDNH Pav. 75')},
          {'key': 'vvc_75a', 'name': this.$gettext('VDNH Pav. 75a')},
          {'key': 'pav7', 'name': this.$gettext('Pavilion #7')},
          {'key': 'expo', 'name': this.$gettext('Expocentre')},
          {'key': 'south', 'name': this.$gettext('South')},
          {'key': 'forum', 'name': this.$gettext('Forum')},
          {'key': 'north', 'name': this.$gettext('North')},
          {'key': 'west', 'name': this.$gettext('West')},
          {'key': 'total', 'name': this.$gettext('Total')},
          {'key': 'crocus_1', 'name': this.$gettext('Crocus 1')},
          {'key': 'crocus_2', 'name': this.$gettext('Crocus 2')},
          {'key': 'crocus_3','name': this.$gettext('Crocus 3')},
          {'key': 'crocus_3_13', 'name': this.$gettext('Crocus 3/13')},
          {'key': 'crocus_3_14','name': this.$gettext('Crocus 3/14')},
          {'key': 'crocus_3_15', 'name': this.$gettext('Crocus 3/15')},
          {'key': 'unknown','name': this.$gettext('Unknown')},
          {'key': 'office', 'name': this.$gettext('Preprint in office')},
          {'key': 'guest','name': this.$gettext('Guest house')},
          {'key': 'zone_total', 'name': this.$gettext('Zones total')}
          ]
      }
    },
    methods: {
      addField() {
        this.value.push({
          zone: null,
          pterm: '192.168.%'
        })
      },
      handleDelete(e, index) {
        this.value.splice(index, 1)
      }
    }
  }
</script>

<style scoped>

</style>
